<template>
  <div class="vue-tui-editor"></div>
</template>

<script>
import 'tui-color-picker/dist/tui-color-picker'
import TuiEditor from 'tui-editor'
import 'tui-editor/dist/tui-editor-extColorSyntax'
import 'tui-editor/dist/tui-editor.css'
import 'tui-editor/dist/tui-editor-contents.css'
import 'tui-color-picker/dist/tui-color-picker.css'
import './codemirror.css'

export default {
  props: {
    options: Object
  },
  mounted () {
    this.editor = new TuiEditor(Object.assign({
      el: this.$el,
      initialEditType: 'wysiwyg',
      previewStyle: 'vertical',
      height: '300px',
      language: 'ko_KR',
      hideModeSwitch: true,
      exts: ['colorSyntax']
    }, this.options))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stone-tui-editor/stone-tui-editor.vue